import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSelect = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
        fontSize: '0.875rem',

        '& .MuiSelect-select': {
            padding: '8px 12px',
        },
    },

    '& .MuiInputLabel-root': {
        fontSize: '0.8125rem',
        fontWeight: 500,
        color: '#455a64',
        transform: 'translate(14px, -9px) scale(0.9)',
    },
}));

const StyledMenuItem = styled(MenuItem)({
    fontSize: '0.875rem',
    padding: '8px 12px',
    minHeight: 'auto',
});

const LsSelect = ({
    label,
    options = [],
    value,
    onChange,
    required = false,
    error = false,
    helperText,
    size = 'small',
    ...props
}) => {
    return (
        <StyledSelect
            select
            label={label}
            value={value}
            onChange={onChange}
            required={required}
            error={error}
            helperText={helperText}
            size={size}
            InputLabelProps={{ shrink: true }}
            {...props}
        >
            {options.map((option) => (
                <StyledMenuItem key={option.value} value={option.value}>
                    {option.label}
                </StyledMenuItem>
            ))}
        </StyledSelect>
    );
};

export default LsSelect;